import { makeStyles } from "@material-ui/core";
import { buttonBackground } from "../../hooks/use-map-theme-styles";
export const drawerWidth = "50px";

export default makeStyles((theme) => {
	const card = {
		padding: theme.spacing(2),
		borderRadius: "4px",
	};

	const headerCard = {
		...card,
		height: "105px",
	};

	const itemHeader = {
		borderBottom: `1px solid ${theme.palette.background.default}`,
		display: "flex",
		paddingLeft: theme.spacing(4),
		paddingRight: theme.spacing(2),
		justifyContent: "space-between",
		width: "100%",
	};

	return {
		headerSingleCard: {
			...card,
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			paddingLeft: theme.spacing(2),
		},
		headerDetailsCard: {
			...headerCard,
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			paddingLeft: theme.spacing(2),
		},
		formCard: {
			...card,
			display: "flex",
			alignItems: "center",
			width: "100%",
			height: "76px",
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
			justifyContent: "space-between",
			minWidth: "600px",
		},

		detailsItemBox: {
			"@media (max-width: 1560px)": {
				flexDirection: "column",
				gap: "4px",
			},
			flexGrow: 1,
			justifyContent: "space-between",
			flexDirection: "row",
		},
		detailsItem: {
			"@media (max-width: 1560px)": {
				width: "80%",
				display: "flex",
			},
			paddingLeft: theme.spacing(1),
			minWidth: "20%",
		},
		detailsItemBoxShrunk: {
			flexDirection: "column",
			gap: "4px",
		},
		detailsItemShrunk: {
			width: "80%",
			display: "flex",
		},
		table: {
			width: "100%",
			borderCollapse: "collapse",
			"& td": {
				height: "50px",
			},
		},
		miniTableCA: {
			width: "100%",
			borderCollapse: "collapse",
			tableLayout: "fixed",
			"& td": {
				height: "50px",
				padding: "0 26px",
			},
			"& th": {
				padding: "0 26px",
			},
		},

		br: {
			borderRight: `1px solid ${theme.palette.grey[400]}`,
		},
		detailsLargeItem: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			width: "100%",
		},
		fw400: {
			fontWeight: 400,
		},
		fw500: {
			fontWeight: 500,
		},
		fw600: {
			fontWeight: 600,
		},
		mr1: {
			marginRight: theme.spacing(1),
		},
		sideDrawer: {
			"&.MuiDrawer-paper": {
				top: "75px",
			},
		},
		openDrawer: {
			width: "38%",
			transition: "width 0.3s",
		},
		closedDrawer: {
			width: drawerWidth,
			transition: "width 0.3s",
		},
		iconBar: {
			minHeight: "95vh",
			height: "96%",
			paddingTop: theme.spacing(2),
			width: "54px",
			borderRight: `1px solid ${theme.palette.tableDivider.main}`,
		},
		activeIconContainer: {
			backgroundColor: buttonBackground,
			borderRadius: "10px",
		},
		bodyRoot: {
			borderRadius: "4px",
			marginTop: theme.spacing(3),
		},
		bodyItemHeaderTop: {
			...itemHeader,
			borderRadius: "4px 4px 0 0",
		},
		bodyItemHeader: {
			...itemHeader,
		},
		collapseTitle: {
			marginLeft: "14px",
		},
		icon: {
			fontSize: "17px",
		},
		recordDrawerLink: {
			textDecorationColor: "#cddcdc",
		},
		smallItem: {
			maxWidth: "100px",
			verticalAlign: "baseline",
		},
		cellRightAlignment: {
			textAlign: "right",
		},
		mediumItem: {
			maxWidth: "200px",
		},
		row: {
			display: "flex",
			width: "100%",
		},
		wrappedRow: {
			display: "flex",
			width: "100%",
			flexWrap: "wrap",
		},
		formsHeader: {
			...itemHeader,
			height: "64px",
			display: "flex",
			alignItems: "center",
		},
		formsContent: {
			paddingBottom: theme.spacing(3),
			marginInline: theme.spacing(5),
			boxShadow: "none",
		},
		condition: {
			margin: theme.spacing(1, 0, 2, 0),
			width: "50%",
		},
		divider: {
			width: "100%",
			borderTop: "1px solid #cddcdc",
		},
		fullWidth: {
			width: "100%",
		},
		revokedIcon: {
			position: "absolute",
			left: "-30px",
		},
		selectedViewName: {
			fontWeight: 600,
		},
		hyperLink: {
			color: "blue",
			textDecoration: "underline",
		},
	};
});
